export default "__VITE_ASSET__kp3xJ1Jc__"